import { useEffect } from 'react';

/** Lock background scroll while `active` (e.g. a modal is open). Nesting-safe. */
const useLockBody = (active = true) => {
  useEffect(() => {
    if (!active) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = prev; };
  }, [active]);
};

export default useLockBody;
